import { render, staticRenderFns } from "./StampHistory.vue?vue&type=template&id=0e4861bd&scoped=true&"
import script from "./StampHistory.vue?vue&type=script&lang=js&"
export * from "./StampHistory.vue?vue&type=script&lang=js&"
import style0 from "./StampHistory.vue?vue&type=style&index=0&id=0e4861bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4861bd",
  null
  
)

export default component.exports